import React from "react";
import { useTranslation } from "react-i18next";
import ReactSwitch from "react-switch";
import { useSnapshot } from "valtio";
import SimpleBar from "simplebar-react";

import {
    designStore,
    generalConfigStore,
    setBasket,
    setBreadcrumbTrail,
    setInformationMessageCompositeProduct,
    setPageOrderTakingCompositeProduct,
} from "@store";

export function MainContent(): JSX.Element {
    const { t } = useTranslation();

    const {
        informationMessageCompositeProduct,
        basket,
        breadcrumbTrail,
    } = useSnapshot(designStore);

    const {
        project: { template },
    } = useSnapshot(generalConfigStore);

    const orderTakingPage = template.pages.ways[
        "orderTaking"
    ] as OrderTakingPageType;
    function handleBreadcrumbTrailChange() {
        setBreadcrumbTrail(!breadcrumbTrail);
        setPageOrderTakingCompositeProduct({
            ...orderTakingPage.compositeProduct,
            breadcrumbTrail: !breadcrumbTrail,
        });
    }

    function handleInformationMessageChange() {
        setInformationMessageCompositeProduct(
            !informationMessageCompositeProduct
        );
        setPageOrderTakingCompositeProduct({
            ...orderTakingPage.compositeProduct,
            informationMessage: !informationMessageCompositeProduct,
        });
    }

    function handleMinMaxChange() {
        setPageOrderTakingCompositeProduct({
            ...orderTakingPage.compositeProduct,
            isMinMaxShown: !orderTakingPage.compositeProduct.isMinMaxShown,
        });
    }

    function handleTagsChange() {
        setPageOrderTakingCompositeProduct({
            ...orderTakingPage.compositeProduct,
            isTags: !orderTakingPage.compositeProduct.isTags,
        });
    }

    function handleBasketChange() {
        setBasket(!basket);
        setPageOrderTakingCompositeProduct({
            ...orderTakingPage.compositeProduct,
            basket: !basket,
        });
    }

    return (
        <div className="d-flex flex-column justify-content-between mx-2 m-2 rounded border">
            <div
                className="text-left px-4 d-flex align-items-center cursor__clz"
                style={{
                    backgroundColor: "#EDEDED",
                    height: "40px",
                    fontSize: "20px",
                }}
            >
                {t("Composite product step")}
            </div>
            <SimpleBar
                autoHide={true}
                style={{ maxHeight: 250, borderColor: "#CECECE" }}
            >
                <div className="p-4">
                    <div className="py-2 d-flex flex-rows justify-content-between align-items-center">
                        <div>{t("breadcrumb trail")}</div>
                        <ReactSwitch
                            uncheckedIcon={false}
                            checkedIcon={false}
                            handleDiameter={26}
                            offColor="#f7b4b8"
                            offHandleColor="#E30613"
                            checked={breadcrumbTrail}
                            onChange={handleBreadcrumbTrailChange}
                            onColor="#c2eddd"
                            onHandleColor="#34C38F"
                            width={50}
                            height={20}
                            className="cgt_icn_BreadcrumbTrail"
                            data-testid="toggle-breadcrumb-composite-product"
                            aria-label={t("breadcrumb trail")}
                        />
                    </div>
                    <div className="py-2 d-flex flex-rows justify-content-between align-items-center">
                        <div>
                            {t("Information message")}
                            <div style={{ color: "#B7B7B7", fontSize: "13px" }}>
                                {t("Please choose your dish")}
                            </div>
                        </div>
                        <ReactSwitch
                            uncheckedIcon={false}
                            checkedIcon={false}
                            handleDiameter={26}
                            offColor="#f7b4b8"
                            offHandleColor="#E30613"
                            checked={informationMessageCompositeProduct}
                            onChange={handleInformationMessageChange}
                            onColor="#c2eddd"
                            onHandleColor="#34C38F"
                            width={50}
                            height={20}
                            className="cgt_txt_informationMessage"
                            data-testid="toggle-information-message-composite-product"
                            aria-label={t("Information message")}
                        />
                    </div>
                    <div className="py-2 d-flex flex-rows justify-content-between align-items-center">
                        <div>{t("Show (Min:Max)")}</div>
                        <ReactSwitch
                            uncheckedIcon={false}
                            checkedIcon={false}
                            handleDiameter={26}
                            offColor="#f7b4b8"
                            offHandleColor="#E30613"
                            checked={
                                orderTakingPage.compositeProduct.isMinMaxShown
                            }
                            onChange={handleMinMaxChange}
                            onColor="#c2eddd"
                            onHandleColor="#34C38F"
                            width={50}
                            height={20}
                            className="cgt_icn_displayMinMax"
                            data-testid="toggle-min-max-composite-product"
                            aria-label={t("Show (Min:Max)")}
                        />
                    </div>
                    <div className="py-2 d-flex flex-rows justify-content-between align-items-center">
                        <div>{t("Display filters ( tags )")}</div>
                        <ReactSwitch
                            uncheckedIcon={false}
                            checkedIcon={false}
                            handleDiameter={26}
                            offColor="#f7b4b8"
                            offHandleColor="#E30613"
                            checked={orderTakingPage.compositeProduct.isTags}
                            onChange={handleTagsChange}
                            onColor="#c2eddd"
                            onHandleColor="#34C38F"
                            width={50}
                            height={20}
                            className="cgt_icn_displayTags"
                            disabled={!orderTakingPage.isTags}
                            data-testid="toggle-tags-composite-product"
                            aria-label={t("Display filters ( tags )")}
                        />
                    </div>
                    <div className="py-2 d-flex flex-rows justify-content-between align-items-center">
                        <div>
                            {t("Basket")}
                            <div style={{ color: "#B7B7B7", fontSize: "13px" }}>
                                {t(
                                    "Avoid this option when using the article comment module or a sub-step"
                                )}
                            </div>
                        </div>
                        <ReactSwitch
                            uncheckedIcon={false}
                            checkedIcon={false}
                            handleDiameter={26}
                            offColor="#f7b4b8"
                            offHandleColor="#E30613"
                            checked={basket}
                            onChange={handleBasketChange}
                            onColor="#c2eddd"
                            onHandleColor="#34C38F"
                            width={50}
                            height={20}
                            className="cgt_icn_shoppingCart"
                            data-testid="toggle-basket-composite-product"
                            aria-label={t("Basket")}
                        />
                    </div>
                </div>
            </SimpleBar>
        </div>
    );
}
